<template>
  <div>
    <div class="animated fadeIn">
      <div class="card">
        <div class="card-header">{{ aLang.c_list }} thuyết minh</div>
        <div class="card-body" v-if="!mData.isRegisteredAudio"></div>
        <div class="card-body" v-if="mData.isRegisteredAudio">
          <div class="text-left">
            <b-collapse
              v-bind:visible="mData.tableRules.showFormSearch"
              id="myFormSearch"
            >
              <b-card class="card-search">
                <el-form
                  ref="myForm"
                  label-position="top"
                  @submit.native.prevent
                  :model="mData.tableRules.dataSearch.value"
                >
                  <b-row>
                    <b-col md="4">
                      <el-form-item label="ID thuyết minh" prop="">
                        <el-input
                          v-model="mData.tableRules.dataSearch.value.guideCode"
                          clearable
                          placeholder="Nhập từ khóa (nhấn enter để tìm kiếm)"
                        >
                        </el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Nội dung tìm kiếm">
                        <el-autocomplete
                          clearable
                          class="inline-input"
                          v-model="textSearch"
                          :fetch-suggestions="querySearchName"
                          placeholder="Nhập nội dung để tìm kiếm"
                          :trigger-on-focus="false"
                          @select="handleSelectTextSearch"
                          @clear="clearTextSearch"
                        >
                          <template slot-scope="{ item }">
                            <span class="link">{{ item }}</span>
                          </template>
                        </el-autocomplete>
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <el-form-item class="text-center mb-0">
                    <el-button
                      type="info"
                      native-type="submit"
                      v-ladda
                      plain
                      @click="fn_tableSearch()"
                      >{{ aLang.c_search }}</el-button
                    >
                  </el-form-item>
                </el-form>
              </b-card>
            </b-collapse>
          </div>
          <b-row>
            <b-col :class="'col-md-8'"> </b-col>
            <b-col :class="'col-md-4'">
              <div class="text-right mb-2">
                <el-button @click="fn_tableShowFormSearch()" type="info" plain>
                  {{ aLang.c_showHideSearch }}
                </el-button>
                <el-button @click="fn_handle('create')" type="info" plain>
                  {{ aLang.c_create }}
                </el-button>
              </div>
            </b-col>
          </b-row>
          <el-table
            :data="mData.tableRules.data"
            max-height="550"
            style="width: 100%"
            border
          >
            <el-table-column
              prop="guideCode"
              label="ID thuyết minh"
              width="100"
              align="center"
            />
            <el-table-column prop="guideName" label="Tên hiện vật" min-width="180" />
            <el-table-column prop="description" label="Nội dung" min-width="200" />
            <!-- <el-table-column
              prop="languageCode"
              label="Ngôn ngữ"
              width="130"
            /> -->
            <el-table-column label="Ngày cập nhật" width="170" align="center">
              <template slot-scope="scope">
                {{ formatDateTime(scope.row.modifyTime) }}
              </template>
            </el-table-column>
            <el-table-column label="Hiển thị" width="110" align="center">
              <template slot-scope="scope">
                <el-checkbox
                  v-model="scope.row.isActive"
                  @change="fn_handle('changeActive', scope.$index, scope.row)"
                />
              </template>
            </el-table-column>
            <el-table-column label="Thao tác" width="150">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  @click="fn_handle('detail', scope.$index, scope.row)"
                  v-b-popover.hover.left="aLang.c_detail"
                >
                  <i class="fa fa-eye"></i>
                </el-button>
                <el-button
                  size="mini"
                  @click="fn_handle('update', scope.$index, scope.row)"
                  v-b-popover.hover.left="aLang.c_update"
                >
                  <i class="icon-pencil icons"></i>
                </el-button>
                <el-button
                  size="mini"
                  @click="fn_handle('delete', scope.$index, scope.row)"
                  v-b-popover.hover.left="aLang.c_delete"
                >
                  <i class="icon-trash icons"></i>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
            <div class="col-md-4">
              <div v-if="mData.tableRules.allowSelect">
                {{ aLang.c_select }}:
                {{ mData.tableRules.recordSelected.length }}
              </div>
            </div>
            <div class="col-md-8 text-right">
              <el-pagination
                @size-change="fn_tableSizeChange"
                @current-change="fn_tableCurentChange"
                @prev-click="fn_tablePrevClick"
                @next-click="fn_tableNextClick"
                :page-sizes="mData.tableRules.lengthMenu"
                :page-size="mData.tableRules.limit"
                :current-page="mData.tableRules.page"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="mData.tableRules.total"
                :pager-count="5"
              ></el-pagination>
            </div>
          </b-row>
        </div>
      </div>
    </div>
    <el-dialog
      class="dialog__register"
      :visible.sync="dialogRegisterVisible"
      :show-close="false"
      width="500px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="body-dialog">
        <div class="icon-alert animate__animated animate__rotateInDownLeft">
          <div class="icon-alert-content">i</div>
        </div>
        <h5 class="title mb-0">
          Bạn có muốn đăng ký sử dụng chức năng Thuyết minh tự động?
        </h5>
        <div class="mt-4">
          <el-button @click="registerAudio" type="primary" plain :loading="loadingButton">
            Đồng ý
          </el-button>
          <el-button @click="closeDialog" type="info" plain>
            {{ aLang.c_cancel }}
          </el-button>
        </div>
      </div>
    </el-dialog>
    <Loading v-if="loading"></Loading>
  </div>
</template>
<script>
import LanguageService from "../../../service/LanguageService";
import ExtensionService from "../../../service/ExtensionService";
import MethodService from "../../../service/MethodService";
import mushroomDulich from "../../../service/api/dulich-api";
import DDATApi from "../../../moduleApi/DDATApi";
import mushroomTrangVang from "../../../service/api/trangvang-api";
import "animate.css";
import AutomaticCommentaryModel from "./AutomaticCommentaryModel";
import Loading from "@/component/Loading";
export default {
  components: {
    Loading,
  },
  data() {
    return {
      aLang: LanguageService.lang,
      dialogRegisterVisible: false,
      loading: true,
      loadingButton: false,
      textSearch: undefined,
      mData: {
        currentUser: MethodService.copyObject(MethodService.getCurrentUser()),
        listFindText: [],
        moduleName: "AutomaticCommentary",
        tableRules: MethodService.copyObject(AutomaticCommentaryModel.tableRules),
        isRegisteredAudio: false,
        safePlaceData: undefined,
        safePlaceDetailAddress: {
          provinceCode: undefined,
          provinceName: undefined,
          communeCode: undefined,
          communeName: undefined,
        },
        coordinates: {
          longitude: undefined,
          latitude: undefined,
        },
      },
    };
  },
  methods: {
    getListAgmGuide() {
      this.loading = true;
      let header = {
        "X-HTTP-Method-Override": "agm_get_guide",
      };
      let data = {
        start: this.mData.tableRules.offset,
        limit: this.mData.tableRules.limit,
        placeCode: this.mData.safePlaceData.agmPlace.placeCode,
        guideCode: this.mData.tableRules.dataSearch.value.guideCode,
        keyword: this.mData.tableRules.dataSearch.value.keyword,
        sort: "-guideCode",
      };
      this.$router
        .replace({
          name: "Admin-" + this.mData.moduleName + "-list",
          query: {
            limit: this.mData.tableRules.limit,
            page: this.mData.tableRules.page,
            sort: this.mData.tableRules.sort,
            filters: this.mData.tableRules.filters,
            showFormSearch: this.mData.tableRules.showFormSearch,
          },
        })
        .catch(() => {});
      Promise.all([
        mushroomDulich.thedulich.agm_get_guideAsync({
          body: data
        }),
      ])
        .then((res) => {
          if (res.length > 0) {
            this.mData.tableRules.total = res[0].result.total;
            this.mData.tableRules.page =
              this.mData.tableRules.offset / this.mData.tableRules.limit + 1;
            
            const rawData = res[0].result.data || [];
            this.mData.tableRules.data = [...rawData].sort((a, b) => {
              const valA = a.guideCode ? String(a.guideCode) : "";
              const valB = b.guideCode ? String(b.guideCode) : "";
              if (valA && valB) {
                return valB.localeCompare(valA, undefined, { numeric: true, sensitivity: "base" });
              }
              return (b.id || 0) - (a.id || 0);
            });
          }
          setTimeout(() => {
            this.loading = false;
            MethodService.stopLadda();
          }, 1000 * 0.5);
        })
        .catch(() => {
          window.toastr.error("Có lỗi xảy ra, vui lòng thử lại!");
          this.loading = false;
          MethodService.stopLadda();
        });
    },
    async querySearchName(queryString, cb) {
      try {
        queryString = queryString.trim();
        const header = {
          "X-HTTP-Method-Override": "agm_suggest_search",
        };
        const body = {
          keyword: queryString,
          placeCode: this.mData.safePlaceData.agmPlace.placeCode,
        };
        const suggestText = await mushroomDulich.thedulich.agm_suggest_searchAsync({
          body: body
        });
        if (
          suggestText.result &&
          suggestText.result.data &&
          suggestText.result.data.length > 0
        ) {
          this.mData.listFindText = suggestText.result.data;
        } else {
          this.mData.listFindText = []
        }
        let results = this.mData.listFindText;
        cb(results);
      } catch (err) {
        console.log("err", err);
        let data = JSON.parse(err.detail);
        if (data && data.param && data.param.messages && data.param.messages.length > 0) {
          window.toastr.error(data.param.messages.join(" "));
        } else {
          window.toastr.error("Có lỗi xảy ra vui lòng thử lại!");
        }
      }
    },
    handleSelectTextSearch(item) {
      this.mData.tableRules.dataSearch.value.keyword = item.replace("...", "");
      this.textSearch = item.replace("...", "");
    },
    clearTextSearch() {
      this.mData.tableRules.dataSearch.value.keyword = undefined;
      this.textSearch = undefined;
    },
    fn_handle(type, scope, row) {
      if (type == "create") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-create",
        });
      }
      if (type == "update") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-update",
          params: { code: row.guideCode },
        });
      }
      if (type == "detail") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-detail",
          params: { code: row.guideCode },
        });
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning",
        })
          .then(() => {
            this.loading = true;
            this.fn_delete(row);
          })
          .catch(() => {});
      }
      if (type == "changeActive") {
        this.loading = true;
        this.fn_changeActive(row);
      }
    },
    async fn_delete(rowData) {
      try {
        const header = {
          "X-HTTP-Method-Override": "agm_guide_integration_delete",
        };
        const body = {
          clientPlaceCode: this.mData.currentUser.account,
          guideCode: rowData.guideCode,
        };
        await mushroomDulich.thedulich.agm_guide_integration_deleteAsync({
          body: body
        });
        window.toastr.success("Xóa thuyết minh thành công");
        this.loading = false;
        this.getListAgmGuide();
      } catch (err) {
        let data = err.result;
        if (data && data.param && data.param.Messages && data.param.Messages.length > 0) {
          window.toastr.error(data.param.Messages[0]);
        } else {
          window.toastr.error("Xóa thuyết minh thất bại");
        }
        this.loading = false;
      }
    },
    async fn_changeActive(rowData) {
      try {
        let header = {
          "X-HTTP-Method-Override": "agm_guide_integration_change_lock",
        };
        let data = {
          clientPlaceCode: this.mData.currentUser.account,
          guideCode: rowData.guideCode,
          isActive: rowData.isActive,
        };
        await mushroomDulich.thedulich.agm_guide_integration_change_lockAsync({
          body: data
        });
        window.toastr.success("Cập nhật trạng thái hiển thị thuyết minh thành công");
        this.loading = false;
        this.getListAgmGuide();
      } catch (err) {
        console.log("err", err);
        let data = err.result;
        if (data && data.param && data.param.Messages && data.param.Messages.length > 0) {
          window.toastr.error(data.param.Messages[0]);
        } else {
          window.toastr.error("Cập nhật trạng thái hiển thị  thuyết minh thất bại");
        }
        this.loading = false;
      }
    },
    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch = !this.mData.tableRules.showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-list",
        query: query,
      });
    },
    closeDialog() {
      this.loading = false;
      this.dialogRegisterVisible = false;
    },
    registerAudio() {
      this.loading = true;
      this.loadingButton = true;
      let header = {
        "X-HTTP-Method-Override": "agm_place_integration_register",
      };
      let body = {
        clientPlaceCode: this.mData.safePlaceData.du_lieu_khai_bao.user_account,
        placeName: this.mData.safePlaceData.du_lieu_khai_bao.user_ten,
        provinceCode: this.mData.safePlaceDetailAddress.provinceCode,
        provinceName: this.mData.safePlaceDetailAddress.provinceName,
        communeCode: this.mData.safePlaceDetailAddress.communeCode,
        communeName: this.mData.safePlaceDetailAddress.communeName,
        address: this.mData.safePlaceData.du_lieu_khai_bao.user_dia_chi,
        description: undefined,
        destinationUrl: undefined,
        longitude: this.mData.coordinates.longitude,
        latitude: this.mData.coordinates.latitude,
        logoData: this.mData.safePlaceData.du_lieu_khai_bao.user_anh
          ? ExtensionService.urlSurveyImg +
            this.mData.safePlaceData.du_lieu_khai_bao.user_anh
          : undefined,
      };
      Promise.all([
        mushroomDulich.thedulich.agm_place_integration_registerAsync({
          body: body
        }),
      ])
        .then((res) => {
          this.dialogRegisterVisible = false;
          if (res[0].code && res[0].code == 500) {
            let data = JSON.parse(res[0].detail);
            this.$message({
              type: "error",
              message: data.param.messages.join(" "),
            });
          } else {
            this.$message({
              type: "success",
              message: "Đăng ký thành công",
            });
            this.mData.isRegisteredAudio = true;
          }
          setTimeout(() => {
            this.loading = false;
            this.loadingButton = false;
          }, 500);
        })
        .catch(() => {
          this.loading = false;
          this.loadingButton = false;
          this.$message({
            type: "error",
            message: "Đăng ký thất bại",
          });
        });
      this.closeDialog();
    },
    //Check đã đăng ký thuyết minh tự động chưa
    async fn_checkRegister() {
      DDATApi.clearCache();
      let currentUser = MethodService.getCurrentUser();
      const apiRes = await mushroomTrangVang.diem_den_an_toan.listAsync({
        filters: `nguoi_tao_id=${currentUser.id}`,
        limit: 1,
      });
      if (apiRes.result && apiRes.result.length > 0) {
        this.mData.safePlaceData = apiRes.result[0];
        this.getCoordinates(this.mData.safePlaceData.du_lieu_khai_bao.toa_do);
        this.getDataDetailAddress(
          this.mData.safePlaceData.du_lieu_khai_bao.dia_chi_tinh_id,
          this.mData.safePlaceData.du_lieu_khai_bao.dia_chi_xa_id
        );
        // Check đã đăng ký hay chưa
        if (!apiRes.result[0].isRegisteredAudio) {
          this.dialogRegisterVisible = true;
          this.mData.isRegisteredAudio = false;
        } else {
          this.mData.isRegisteredAudio = true;
          this.getListAgmGuide();
        }
      }
    },
    getCoordinates(coordinates) {
      if (!coordinates) return;
      let arr = coordinates.split(",");
      this.mData.coordinates.longitude = arr[0];
      this.mData.coordinates.latitude = arr[1];
    },

    getDataDetailAddress(provinceId, communeId) {
      if (!provinceId || !communeId) return;
      Promise.all([
        mushroomTrangVang.province.findByIdAsync({ id: provinceId }),
        mushroomTrangVang.commune.findByIdAsync({ id: communeId }),
      ])
        .then((res) => {
          this.mData.safePlaceDetailAddress.provinceCode = res[0].result.code;
          this.mData.safePlaceDetailAddress.provinceName = `${res[0].result.type} ${res[0].result.name}`;
          this.mData.safePlaceDetailAddress.communeCode = res[1].result.code;
          this.mData.safePlaceDetailAddress.communeName = `${res[1].result.type} ${res[1].result.name}`;
        })
        .catch((err) => {
          console.info("err", err);
        });
    },
    //Search
    fn_tableSearch() {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );
          this.mData.tableRules.offset = 0;
          this.getListAgmGuide();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.getListAgmGuide();
    },
    formatDateTime(date) {
      return MethodService.formatDate(date, "datetime");
    },
    async checkFullInformation() {
      try {
        DDATApi.clearCache();
        let currentUser = MethodService.getCurrentUser();
        let dataFilter = {
          filters: "nguoi_tao_id=" + currentUser.id,
        };
        let res = await mushroomTrangVang.diem_den_an_toan.listAsync(dataFilter);
        if (res.result && res.result.length > 0) {
          let donViCungCapRes = await mushroomTrangVang.tv_don_vi_cung_cap.findByIdAsync({ id: res.result[0].id });
          this.loading = false;
          if (
            !donViCungCapRes.result ||
            (!res.result[0].du_lieu_khai_bao.user_ten &&
              !res.result[0].du_lieu_khai_bao.chuc_vu &&
              !res.result[0].du_lieu_khai_bao.user_loai)
          ) {
            await this.$confirm(
              "Bạn chưa khai báo đầy đủ thông tin điểm đến, vui lòng khai báo trước khi truy cập tính năng này!",
              {
                confirmButtonText: LanguageService.lang.c_agree,
                showClose: false,
                showCancelButton: false,
                type: "warning",
              }
            );
            this.$router.push({
              name: "Admin-ThongTinDDAT-update",
              params: { id: res.result[0].id },
            });
          } else {
            this.fn_checkRegister();
          }
        }
      } catch (error) {
        console.info("error", error);
      }
    },
    //Lấy filter từ URL
    fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
        if (this.mData.tableRules.dataSearch.value.keyword)
          this.textSearch = this.mData.tableRules.dataSearch.value.keyword;
      }
      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
    },
  },
  created() {
    this.fn_hashUrl();
    // this.fn_checkRegister()
    this.checkFullInformation();
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-autocomplete.inline-input {
  width: 100%;
}
::v-deep .card {
  .card-body {
    min-height: calc(100vh - 156px);
  }
}
::v-deep .card-search {
  .card-body {
    min-height: auto;
  }
}
::v-deep .dialog__register {
  .el-dialog {
    margin-top: 15% !important;
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__body {
      padding: 20px 35px;
      border-radius: 5px;
      background: #fff;
      color: #545454;
      max-height: calc(100vh - 140px);
      overflow: auto;
      .title {
        text-align: center;
        word-break: break-word;
        p {
          margin-bottom: 0;
          font-size: 17px;
          font-weight: 600;
        }
      }
    }
  }
}
.body-dialog {
  padding: 10px 25px;
  word-break: break-word;
  white-space: inherit;
  text-align: center;
  .icon-alert {
    position: relative;
    box-sizing: content-box;
    justify-content: center;
    width: 5em;
    height: 5em;
    border: 0.25em solid transparent;
    border-radius: 50%;
    font-family: inherit;
    line-height: 5em;
    cursor: default;
    border-color: #70d0f0;
    color: #3fc3ee;
    margin: 0 auto;
    .icon-alert-content {
      font-size: 60px;
    }
  }
  .title {
    margin-top: 15px;
    text-align: center;
    font-weight: 600;
    line-height: normal;
  }
}
</style>
